module.exports = __webpack_public_path__ + "static/media/cc-stripe.16774769.svg";